/**
 * Every starter suggestion the empty chat can offer (`agentStarters.ts`).
 * A package (P2–P5) adds its own by creating `starters/<domain>.ts`
 * exporting a `<domain>AgentStarters: AgentStarterSuggestion[]` list (each
 * built with `defineAgentStarter`, in its own Tolgee namespace, `match`ing
 * its own pages) and spreading it in here: one import, one line. A starter
 * whose tool or page needs an organisation capability names it in
 * `requiredCapabilities`; the panel then offers it only to organisations
 * that have all of them (it takes no slot elsewhere).
 */
import type { AgentStarterSuggestion } from "./agentStarters.js";
import { coreAgentStarters } from "./coreStarters.js";
import { templatesAgentStarters } from "./templates.js";

export const agentStarterRegistry: readonly AgentStarterSuggestion[] = [
  ...coreAgentStarters,
  ...templatesAgentStarters,
];
